import { render } from "./Orbital.vue?vue&type=template&id=9039bc06"
import script from "./Orbital.vue?vue&type=script&lang=js"
export * from "./Orbital.vue?vue&type=script&lang=js"

import exportComponent from "/home/eymekkjd/infos-projet.app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__